import HTTP from 'Utils/HTTP';
import CustomSelect from 'Utils/CustomSelect';
import List from 'list.js';

class JobsFilter {
	filterOptions = {};
	customSelects = {};
	filterCounts = {};

	constructor(el) {
		this.root = el;

		this.onSelectChange = ::this.onSelectChange;
		this.onSelectedItemClick = ::this.onSelectedItemClick;
		this.onResetFilterClick = ::this.onResetFilterClick;

		Array.from(this.root.querySelectorAll('.js-customSelect')).forEach(el => {
			this.customSelects[el.dataset.name] = new CustomSelect(el);
			this.customSelects[el.dataset.name].on(CustomSelect.CHANGE, this.onSelectChange);
		});

		const resetFilterButton = this.root.querySelector('.js-filterResetButton');
		resetFilterButton && resetFilterButton.addEventListener('click', this.onResetFilterClick);

		this.jobsList = document.querySelector('.js-jobsList');
		this.jobsListCount = this.jobsList.querySelector('.js-jobsListCount');

		this.initSelectedList();

		this.loadData();
		this.initJobsList();
	}

	initSelectedList() {
		this.selectedList = this.root.querySelector('.js-filterSelectedList');
		const selectedTemplateEl = this.selectedList.querySelector('[data-template]');
		selectedTemplateEl.removeAttribute('data-template');
		if (!selectedTemplateEl) return;
		this.selectedItemTemplate = selectedTemplateEl.outerHTML;
		selectedTemplateEl.parentNode.removeChild(selectedTemplateEl);
	}

	loadData() {
		const url = this.root.dataset.filterDataUrl;
		HTTP.get(url).then(res => {
			this.filterData = res.data.filterData;
			this.fillSelects();
			this.jobsList.filter();
			this.checkForUrlGetFilter();
		});
	}

	checkForUrlGetFilter() {
		const urlParams = new URLSearchParams(window.location.search);
		for (const param of urlParams.entries()) {
			const [key, value] = param;
			if (['categories', 'locations', 'targetGroups'].includes(key)) {
				value.split('|').forEach(filterValue => {
					const filterDataItem = this.filterData[key].find(item => {
						return item.internalName === filterValue || item.id === filterValue;
					});

					filterDataItem &&
						this.onSelectChange({
							value: filterValue,
							key,
							text: filterDataItem.name,
						});
				});
			}
		}
	}

	initJobsList() {
		const options = {
			valueNames: [{ data: ['categories', 'locations', 'targetGroups'] }],
		};

		this.jobsList = new List(this.jobsList, options);
		this.jobsList.on('filterComplete', ::this.onFilterComplete);
	}

	fillSelects() {
		const filterData = this.filterData;

		this.countFilterOptions();

		for (const key in this.customSelects) {
			if (Object.hasOwnProperty.call(this.customSelects, key)) {
				const selectData = filterData[key];

				if (key === 'categories') {
					this.customSelects.categories.clear();
					selectData.forEach(item => {
						const pillValue = this.filterCounts[key][item.internalName];
						if (
							(!this.filterOptions.categories ||
								(this.filterOptions.categories &&
									!this.filterOptions.categories.includes(item.internalName))) &&
							pillValue > 0
						) {
							this.customSelects.categories.addSelectOption({
								value: item.internalName,
								key: key,
								content: {
									key: key,
									text: item.name,
									pill: pillValue,
								},
							});
						}
					});
					this.customSelects.categories.updateState();
				}

				if (key === 'targetGroups') {
					this.customSelects.targetGroups.clear();
					selectData.forEach(item => {
						const pillValue = this.filterCounts[key][item.internalName];
						if (
							(!this.filterOptions.targetGroups ||
								(this.filterOptions.targetGroups &&
									!this.filterOptions.targetGroups.includes(item.internalName))) &&
							pillValue > 0
						) {
							this.customSelects.targetGroups.addSelectOption({
								value: item.internalName,
								key: key,
								content: { text: item.name, pill: pillValue },
							});
						}
					});
					this.customSelects.targetGroups.updateState();
				}

				if (key === 'locations') {
					this.customSelects.locations.clear();
					const groupedLocations = selectData.reduce((acc, item) => {
						const { country } = item;

						if (!acc[country]) {
							acc[country] = [];
						}

						acc[country].push({ ...item });

						acc[country].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

						return acc;
					}, {});

					const keys = Object.keys(groupedLocations);
					keys.sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1));

					keys.forEach(country => {
						const locations = groupedLocations[country];

						let addedGroup = false;
						locations.forEach(item => {
							const pillValue = this.filterCounts[key][item.id];
							if (
								(!this.filterOptions.locations ||
									(this.filterOptions.locations &&
										!this.filterOptions.locations.includes(item.id))) &&
								pillValue > 0
							) {
								if (!addedGroup) {
									this.customSelects.locations.addSelectGroup({
										content: { text: country },
									});
									addedGroup = true;
								}
								this.customSelects.locations.addSelectOption({
									value: item.id,
									key: key,
									content: { text: item.name, pill: pillValue },
								});
							}
						});
					});
					this.customSelects.locations.updateState();
				}
			}
		}
	}

	countFilterOptions() {
		this.filterCounts = {
			categories: {},
			locations: {},
			targetGroups: {},
		};

		this.jobsList.items.forEach(item => {
			const values = item.values();
			let filtered = true;

			// categories
			let foundLocation = false;
			let foundTargetGroup = false;

			let locationFilters = this.filterOptions.locations || [];
			locationFilters.forEach(filterOptionValue => {
				if (values.locations.split('|').includes(filterOptionValue)) {
					foundLocation = true;
				}
			});
			if (locationFilters.length === 0) {
				foundLocation = true;
			}

			let targetGroupFilters = this.filterOptions.targetGroups || [];
			targetGroupFilters.forEach(filterOptionValue => {
				if (values.targetGroups.split('|').includes(filterOptionValue)) {
					foundTargetGroup = true;
				}
			});
			if (targetGroupFilters.length === 0) {
				foundTargetGroup = true;
			}

			if (foundTargetGroup && foundLocation) {
				let values = item.values().categories.split('|');
				values.forEach(value => {
					if (!this.filterCounts.categories[value]) {
						this.filterCounts.categories[value] = 0;
					}

					this.filterCounts.categories[value]++;
				});
			}

			// locations
			let foundCategory = false;
			foundTargetGroup = false;

			let categoryFilters = this.filterOptions.categories || [];
			categoryFilters.forEach(filterOptionValue => {
				if (values.categories.split('|').includes(filterOptionValue)) {
					foundCategory = true;
				}
			});
			if (categoryFilters.length === 0) {
				foundCategory = true;
			}

			targetGroupFilters = this.filterOptions.targetGroups || [];
			targetGroupFilters.forEach(filterOptionValue => {
				if (values.targetGroups.split('|').includes(filterOptionValue)) {
					foundTargetGroup = true;
				}
			});
			if (targetGroupFilters.length === 0) {
				foundTargetGroup = true;
			}

			if (foundTargetGroup && foundCategory) {
				let values = item.values().locations.split('|');
				values.forEach(value => {
					if (!this.filterCounts.locations[value]) {
						this.filterCounts.locations[value] = 0;
					}

					this.filterCounts.locations[value]++;
				});
			}

			// targetGroups
			foundCategory = false;
			foundLocation = false;

			categoryFilters = this.filterOptions.categories || [];
			categoryFilters.forEach(filterOptionValue => {
				if (values.categories.split('|').includes(filterOptionValue)) {
					foundCategory = true;
				}
			});
			if (categoryFilters.length === 0) {
				foundCategory = true;
			}

			locationFilters = this.filterOptions.locations || [];
			locationFilters.forEach(filterOptionValue => {
				if (values.locations.split('|').includes(filterOptionValue)) {
					foundLocation = true;
				}
			});
			if (locationFilters.length === 0) {
				foundLocation = true;
			}

			if (foundLocation && foundCategory) {
				let values = item.values().targetGroups.split('|');
				values.forEach(value => {
					if (!this.filterCounts.targetGroups[value]) {
						this.filterCounts.targetGroups[value] = 0;
					}

					this.filterCounts.targetGroups[value]++;
				});
			}
		});
	}

	onSelectChange(e) {
		const { value, key, text } = e;
		this.addSelectedItem(value, key, text);

		if (!this.filterOptions[key]) {
			this.filterOptions[key] = [];
		}
		this.filterOptions[key].push(value);
		this.applyFilterOptions();
	}

	addSelectedItem(value, key, text) {
		const newSelectedItem = this.createElementFromHTML(this.selectedItemTemplate);
		newSelectedItem.dataset.value = value;
		newSelectedItem.dataset.key = key;
		newSelectedItem.innerText = text;
		this.selectedList.appendChild(newSelectedItem);
		newSelectedItem.addEventListener('click', this.onSelectedItemClick);
	}

	applyFilterOptions() {
		const appliedFilterCount = Object.keys(this.filterOptions).reduce((prev, cur) => {
			return prev + this.filterOptions[cur].length;
		}, 0);
		if (appliedFilterCount === 0) {
			this.jobsList.filter();
			return;
		}

		this.jobsList.filter(item => {
			const filtered = {};

			for (const filterKey in this.filterOptions) {
				filtered[filterKey] = this.filterOptions[filterKey].length === 0;
				const itemFilterValue = item.values()[filterKey].split('|');
				if (Object.hasOwnProperty.call(this.filterOptions, filterKey)) {
					const filterOptionValues = this.filterOptions[filterKey];
					filterOptionValues.forEach(filterOptionValue => {
						if (itemFilterValue.includes(filterOptionValue)) {
							filtered[filterKey] = true;
						}
					});
				}
			}

			let isFiltered = true;
			for (const filteredKey in filtered) {
				if (Object.hasOwnProperty.call(filtered, filteredKey)) {
					const filterState = filtered[filteredKey];
					if (!filterState) isFiltered = false;
				}
			}

			return isFiltered;
		});
	}

	onFilterComplete(e) {
		this.fillSelects();
		this.updateJobsCountDisplay();
	}

	onSelectedItemClick(e) {
		const { key, value } = e.currentTarget.dataset;

		this.filterOptions[key] = this.filterOptions[key].filter(
			filterOptionValue => filterOptionValue !== value
		);

		this.selectedList.removeChild(e.currentTarget);
		this.fillSelects();
		this.applyFilterOptions();
	}

	createElementFromHTML(htmlString) {
		var div = document.createElement('div');
		div.innerHTML = htmlString.trim();
		return div.firstChild;
	}

	onResetFilterClick(e) {
		this.selectedList.innerHTML = '';
		this.filterOptions = {};
		this.fillSelects();
		this.applyFilterOptions();
	}

	updateJobsCountDisplay() {
		this.jobsListCount.innerText = `(${this.jobsList.matchingItems.length})`;
	}
}

Array.from(document.querySelectorAll('.js-jobsFilter')).forEach(el => new JobsFilter(el));
